import React, { useState } from 'react'
import { Drawer, Upload, Collapse, Tabs } from 'antd'
import Select from 'react-select'
import { useSelector } from 'react-redux'
import { AiOutlineInbox } from 'react-icons/ai'
import { useSnackbar } from 'notistack'

import { usePet, notifOps, server, stringifyDate } from '../../modules'

import Confirm from '../reusable/confirm'

const { Dragger } = Upload
const { TabPane } = Tabs
const { Panel } = Collapse

const EditHostedDocument = ({ toggle, visible, doc, onPerform }) => {
    const [name, setName] = useState(doc?.name)
    const [allowedRoles, setAllowed] = useState(doc?.roles?.map(role => ({ label: role?.name, value: role?._id })))
    const [roles, setRoles] = useState([])
    const [document, setDocument] = useState([])

    const { enqueueSnackbar } = useSnackbar()

    const { params } = useSelector(state => state.application)

    const close = () => {
        toggle()
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Document has been updated', ops('success'))
        
        setTimeout(close, 300)
    }

    usePet('roles', { limit: 100 }, { notify: true, callback: async ({ data }) => { 
        setRoles(data?.roles?.map(store => ({
            label: store.name,
            value: store._id
        })))
    } })

    const [{ loading }, execute] = usePet('updateHostedDocument', {
        id: doc?._id,
        name,
        roles: allowedRoles?.map(role => role.value),
        document: document[0]?.originFileObj
    }, { notify: true, hasFile: true, callback: onComplete, manual: true })


    const props = {
        name: 'referral',
        fileList: document,
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        onChange: info => {
            let { fileList } = info
            fileList = fileList.slice(-1)

            let isNotPDF = fileList[0]?.type !== 'application/pdf'
            if (isNotPDF)
                enqueueSnackbar('Please upload a pdf file', notifOps('warning'))
    
            let isLarge = (fileList[0]?.size / 1024 / 1024) > params?.maxFileUploadSize
            if (isLarge)
                enqueueSnackbar(`Please upload a file smaller than ${params?.maxFileUploadSize} MB`, notifOps('warning'))
            
            if (!(isNotPDF || isLarge))
                setDocument(fileList)
        },
        beforeUpload: () => false,
        onDrop: (e) => {
            console.log('Dropped files', e.dataTransfer.files);
        },
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={ () => Confirm({
                        title: 'Update Document?',
                        message: 'Please confirm before updating this document?',
                        onOk: execute,
                        okText: 'Update Document',
                    })} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Update Document</button>
                </div>
            }
            width={600}>
            <p className="font-extrabold text-3xl mb-0">Edit Hosted Document</p>
            <Tabs>
                <TabPane key="0" tab="Document Details">
                    <div className="divide-y divide-light-gray-400">
                        <div className="flex flex-wrap mt-3 -mx-3">
                            <div className="w-full md:w-2/3 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Document Name
                                </label>
                                <input 
                                    onChange={ e => setName(e.target.value) }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-doc-name" 
                                    type="text" 
                                    value={ name }
                                    name="name"
                                    placeholder="Discharge Summary" />
                            </div>
                        </div>
                        <div>
                            <p className="font-bold my-3">Allowed Roles</p>
                            <Select
                                isMulti 
                                value={ allowedRoles }
                                onChange={ setAllowed }
                                options={ roles }
                                placeholder="Select Roles" />
                        </div>
                        <div>
                            <p className="font-bold my-3">Upload Document</p>
                            <Dragger {...props}>
                                <p className="ant-upload-drag-icon flex justify-center">
                                    <AiOutlineInbox size={40} />
                                </p>
                                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                <p className="ant-upload-hint">Please select a pdf file</p>
                            </Dragger>
                        </div>
                    </div>
                </TabPane>
                <TabPane key="1" tab="Preview">
                    <iframe width="100%" height="768px" src={ `${server}/uploads/hosted-documents/${doc?.fileName}?session=${sessionStorage.getItem('token')}`} />
                </TabPane>
                <TabPane key="2" tab="Previous Versions">
                    {
                        doc?.previous?.length > 0 ?
                            <Collapse>
                                {
                                    doc?.previous.map((prev, i) =>
                                        <Panel 
                                            key={ i }
                                            header={ 
                                                <div>
                                                    <div className="">Version { i + 1 }</div>
                                                    <p className="text-gray-500 mb-0 text-xs italic">Uploaded by { prev?.uploadedBy?.name } on { stringifyDate(prev?.date) }</p>
                                                </div>
                                            }>
                                            <iframe width="100%" height="768px" src={ `${server}/uploads/hosted-documents/${prev?.fileName}?session=${sessionStorage.getItem('token')}`} />     
                                        </Panel>
                                    )
                                }
                            </Collapse>
                        :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">No previous versions of this document were found</p>
                            </div>
                    }
                </TabPane>
                <TabPane key="3" tab="Access Log">
                </TabPane>
            </Tabs>
        </Drawer>
    )
}

export default EditHostedDocument